import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Favorites from './pages/Favorites';
import GamePlayer from './pages/GamePlayer';
import Subscribe from './pages/Subscribe';
import Layout from './components/Layout';
import LoginModal from './components/LoginModal';
import Notification from './components/Notification';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';

function App() {
  return (
    <NotificationProvider>
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/play/:gameId" element={<GamePlayer />} />
            </Routes>
          </Layout>
          <LoginModal />
          <Notification />
        </Router>
      </AuthProvider>
    </NotificationProvider>
  );
}

export default App;

